module.exports = __webpack_public_path__ + "assets/img/mecha-ce7c92e4.png";